import { Box } from '@mui/material';

export default function EnabledRouteList({
  routes,
  children,
  canTakeRoute,
  renderActiveStateRoute,
  renderEmptyStateEnabledRoute,
  renderEnabledRouteAlert,
}) {
  const availablesRoute = routes?.filter((route) => !route.clouder) || [];
  const noAvailablesRoutes = routes?.filter((route) => route.clouder) || [];

  return (
    <Box>
      {!canTakeRoute && renderActiveStateRoute()}

      {renderEnabledRouteAlert()}

      {availablesRoute.length === 0 &&
        canTakeRoute &&
        renderEmptyStateEnabledRoute()}

      {availablesRoute.map(children)}
      {noAvailablesRoutes.map(children)}
    </Box>
  );
}
